import { EASE } from "@nnf3d/lib";
import type { Transition, Variants } from "motion/react";

const transitionAnimate = { duration: 0.8, ease: EASE.OUT_EXPO } as const satisfies Transition;

const transitionExit = { duration: 0.15, ease: EASE.IN_SINE } as const satisfies Transition;

const introVariants = {
	initial: { opacity: 0, y: "1rem" },
	animate: { opacity: 1, y: "0", transition: transitionAnimate },
	exit: { opacity: 0, y: "0.5rem", transition: transitionExit },
} as const satisfies Variants;

export { introVariants, transitionAnimate, transitionExit };
